import { parse } from 'query-string';
const isArray = (obj) => Object.prototype.toString.call(obj) === '[object Array]';
export const getQueryString = (params) => {
    return Object.keys(params).reduce((additionalParamsString, key) => {
        if (params[key]) {
            return `${additionalParamsString}&${key}=${params[key]}`;
        }
        return additionalParamsString;
    }, '');
};
export const doesUrlHasSearchParam = (searchParamKey) => {
    if (!searchParamKey) {
        return false;
    }
    return !!parse(location.search)[searchParamKey];
};
export const getUrlSearchParam = (searchParamKey) => {
    if (!searchParamKey) {
        return '';
    }
    const searchValue = parse(location.search)[searchParamKey];
    return (isArray(searchValue) ? searchValue[0] : searchValue || '');
};
//# sourceMappingURL=url.js.map